import { Row, Table, InputGroup, FormControl, Col, Button, Spinner } from "react-bootstrap";
import { GoSearch } from "react-icons/go"
import { useState } from "react";
import AzioniPerVerificati from "./AzioniPerVerificati";
import BottoneFile from '../../Utilities/BottoneFile';
import AggiungiPartecipanteModal from "./AggiungiPartecipanteModal";
import { BsPlusLg } from "react-icons/bs"

export default function GestionePartecipanti({
    comId,
    setShowToast,
    setMessaggioToast,
    setTitoloToast,
    setRicaricaPartecipanti,
    partecipanti,
    impostazioni,
    ricaricaPartecipanti,
    // AGGIUNGIAMO LE PROPS PER LA RICERCA PASSATE DAL PADRE
    searchTerm,
    setSearchTerm
}) {
    // Stato per gestire la visualizzazione del modale di aggiunta partecipante
    const [showAggiungiPartecipante, setShowAggiungiPartecipante] = useState(false);
    
    // RIMOSSO: const [ricercaPartecipanti, setRicercaPartecipanti] = useState("")

    return (
        <>
            {/*Contenitore principale della gestione admin */}
            <div className="container-sm  p-0 p-md-4">
                {/*Sezione superiore con titolo, pulsante e barra di ricerca */}
                <Row className="d-flex justify-content-between mb-3">
                    <Col md={4} xs={12}>
                        <h4 className="w-auto"><strong>Partecipanti</strong></h4>
                    </Col>
                    <Col md={5} xs={12} className="text-md-end mb-2 mb-md-0">
                        <Button className="w-auto"
                            onClick={() => { setShowAggiungiPartecipante(true) }}
                        >Aggiungi un partecipante <BsPlusLg className="m-auto" /></Button>
                    </Col>
                    <Col md={3} xs={12}>
                        {/* Barra di ricerca collegata al padre */}
                        <InputGroup>
                            <InputGroup.Text id="basic-addon1">
                                <GoSearch />
                            </InputGroup.Text>
                            <FormControl placeholder="Cerca nome, cognome, email..."
                                value={searchTerm} // <-- Usa il valore del padre
                                onChange={(ev) => { setSearchTerm(ev.target.value) }} // <-- Aggiorna lo stato nel padre
                            />
                        </InputGroup>
                    </Col>
                </Row>

                <BottoneFile comId={comId}
                    setShowToast={setShowToast}
                    setMessaggioToast={setMessaggioToast}
                    setTitoloToast={setTitoloToast}
                    setRicaricaPartecipanti={setRicaricaPartecipanti}
                />
                
                {/* Tabella con la lista dei partecipanti */}
                <Table className='mt-3' striped bordered hover responsive>
                    <thead>
                        <tr>
                            <th>Cognome</th>
                            <th>Nome</th>
                            <th>Codice Fiscale</th>
                            <th >Azioni</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            ricaricaPartecipanti ? (
                                <tr>
                                    <td colSpan={4} style={{ textAlign: "center" }}> {/* Sistemato colSpan da 7 a 4 */}
                                        <Spinner animation="border" role="status">
                                            <span className="visually-hidden">Caricamento...</span>
                                        </Spinner>
                                    </td>
                                </tr>
                            ) : partecipanti.length > 0 ? (
                                partecipanti
                                    // RIMOSSO IL .filter() LOCALE: IL BACKEND CI DA GIA' I DATI FILTRATI!
                                    .sort((a, b) => {
                                        // Ordinamento locale sui 10 elementi della pagina
                                        const cognomeA = a.datiPartecipante.dparCognome.toLowerCase();
                                        const cognomeB = b.datiPartecipante.dparCognome.toLowerCase();
                                        const nomeA = a.datiPartecipante.dparNome.toLowerCase();
                                        const nomeB = b.datiPartecipante.dparNome.toLowerCase();

                                        if (cognomeA < cognomeB) return -1;
                                        if (cognomeA > cognomeB) return 1;
                                        if (nomeA < nomeB) return -1;
                                        if (nomeA > nomeB) return 1;
                                        return 0;
                                    })
                                    .map((el, index) => (
                                        <tr key={index} className={el.parStato === 'bloccato' ? "row-blocked" : ''}>
                                            <td>{el.datiPartecipante.dparCognome}</td>
                                            <td>{el.datiPartecipante.dparNome}</td>
                                            <td>{el.datiPartecipante.dparCf}</td>
                                            <td>
                                                <AzioniPerVerificati partecipante={el}
                                                    setRicaricaPartecipanti={setRicaricaPartecipanti}
                                                    impostazioni={impostazioni} />
                                            </td>
                                        </tr>
                                    ))
                            ) : (
                                <tr>
                                    <td colSpan={4} className="text-center py-4">
                                        Nessun partecipante trovato.
                                    </td>
                                </tr>
                            )
                        }
                    </tbody>
                </Table>
                
                <AggiungiPartecipanteModal
                    show={showAggiungiPartecipante}
                    setShow={setShowAggiungiPartecipante}
                    comId={comId}
                    setShowToast={setShowToast}
                    setMessaggioToast={setMessaggioToast}
                    setTitoloToast={setTitoloToast}
                    setRicaricaPartecipanti={setRicaricaPartecipanti} />
            </div>
        </>
    )
}